// src/components/Sidebar.js
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaBalanceScale,
  FaUsers,
  FaFolder,
  FaCalendarAlt,
  FaChartPie,
  FaUserFriends,
  FaSignOutAlt,
  FaRobot,
  FaFileContract,
  FaBell,
  FaPhoneAlt,
  FaCloudUploadAlt,
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

function Sidebar({ setToken }) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    setToken(null);
    navigate("/");
  };

  return (
    <>
      {/* زر فتح القائمة */}
      <div className="fixed top-4 right-4 z-50">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-yellow-400 bg-gray-900 p-3 rounded-full shadow-xl hover:scale-110 transition"
        >
          {isOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
        </button>
      </div>

      {/* السايدبار */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            key="sidebar"
            initial={{ x: "100%", opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: "100%", opacity: 0 }}
            transition={{ type: "spring", stiffness: 70, damping: 18 }}
            className="
              fixed top-0 right-0 h-full 
              w-4/5 sm:w-72
              bg-gradient-to-b from-gray-900 to-black 
              text-white shadow-2xl z-40 
              flex flex-col
            "
          >
            {/* العنوان */}
            <div className="p-6 border-b border-gray-700 text-center">
              <h2 className="text-2xl font-bold text-yellow-400 flex items-center gap-2 justify-center">
                <FaBalanceScale /> الافوكاتو
              </h2>
            </div>

            {/* الروابط - مع Scroll موبايل */}
            <nav className="
              flex-1 
              p-6 
              space-y-6 
              text-lg 
              font-medium 
              overflow-y-auto 
              scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-900
            ">
              <Link
                to="/dashboard"
                onClick={() => setIsOpen(false)}
                className="flex items-center gap-3 hover:text-yellow-400 transition"
              >
                ⚖️ لوحة التحكم
              </Link>

              <Link to="/clients" onClick={() => setIsOpen(false)} className="flex items-center gap-3 hover:text-yellow-400 transition">
                <FaUsers /> العملاء
              </Link>

              <Link to="/cases" onClick={() => setIsOpen(false)} className="flex items-center gap-3 hover:text-yellow-400 transition">
                <FaFolder /> القضايا
              </Link>

              <Link to="/schedule" onClick={() => setIsOpen(false)} className="flex items-center gap-3 hover:text-yellow-400 transition">
                <FaCalendarAlt /> المواعيد
              </Link>

              <Link to="/analytics" onClick={() => setIsOpen(false)} className="flex items-center gap-3 hover:text-yellow-400 transition">
                <FaChartPie /> الإحصائيات
              </Link>

              <Link to="/invite" onClick={() => setIsOpen(false)} className="flex items-center gap-3 hover:text-yellow-400 transition">
                <FaUserFriends /> دعوة آخرين
              </Link>

              <Link to="/ai" onClick={() => setIsOpen(false)} className="flex items-center gap-3 hover:text-yellow-400 transition">
                <FaRobot /> الذكاء الاصطناعي
              </Link>

              <Link to="/legal-docs" onClick={() => setIsOpen(false)} className="flex items-center gap-3 hover:text-yellow-400 transition">
                <FaFileContract /> مستلزمات قانونية
              </Link>

              <Link to="/notifications" onClick={() => setIsOpen(false)} className="flex items-center gap-3 hover:text-yellow-400 transition">
                <FaBell /> الإشعارات
              </Link>

              {/* إدارة الملفات */}
              <Link to="/file-manager" onClick={() => setIsOpen(false)} className="flex items-center gap-3 hover:text-yellow-400 transition">
                <FaCloudUploadAlt /> إدارة الملفات
              </Link>

              <Link
                to="/contact-owner"
                onClick={() => setIsOpen(false)}
                className="flex items-center gap-3 p-3 rounded-md hover:bg-gray-800 hover:text-yellow-400 transition mt-6"
              >
                <FaPhoneAlt /> تواصل مع صاحب النظام
              </Link>
            </nav>

            {/* زر الخروج */}
            <div className="p-6 border-t border-gray-700">
              <button
                onClick={handleLogout}
                className="w-full flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 py-3 rounded-lg font-semibold transition"
              >
                <FaSignOutAlt /> تسجيل الخروج
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default Sidebar;
